import { render, staticRenderFns } from "./imgH.vue?vue&type=template&id=774dbe61&scoped=true"
var script = {}
import style0 from "./imgH.vue?vue&type=style&index=0&id=774dbe61&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dbe61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774dbe61')) {
      api.createRecord('774dbe61', component.options)
    } else {
      api.reload('774dbe61', component.options)
    }
    module.hot.accept("./imgH.vue?vue&type=template&id=774dbe61&scoped=true", function () {
      api.rerender('774dbe61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgH.vue"
export default component.exports